import React, {useMemo} from 'react';
import {FullTextSearchRegulatoryDocumentsQuery} from 'features/Search/hooks';
import {SearchResultRegulatoryDocument} from 'features/Search/components/SearchCards/SearchResultCards';
import {Regulation} from 'types';
import {getEntityListColumns, SearchResult} from './SearchResult';
import {useReportsPageColumn} from 'features/Reports/ReportsPageColumns';
import {ReportsTooltipTranslationProvider} from 'features/Reports/ReportsTooltipTranslationProvider';
import {EntityListColumn} from 'components';
import {useTranslation} from 'react-i18next';

const entityName = 'RegulatoryDocuments';

const primitiveColumns: string[] = ['status', 'modelYear'];
const arrayColumns: string[] = [
	'contactPersons',
	'markets',
	'mainKeywords',
	'keywords',
];
const dateColumns: string[] = [
	'modifiedAt',
	'dateEffective',
	'dateNewTypes',
	'dateNewRegistration',
	'comprehensive',
];
const omitColumns: string[] = ['tooltip', 'regulationNumber', 'workflowStatus'];
const quickFilterColumns: string[] = ['markets', 'mainKeywords', 'keywords'];

type RegDocumentSearchResultProps = {
	currentViewKey: string;
	isResultCardFormat: boolean;
	loading: boolean;
	documentData: FullTextSearchRegulatoryDocumentsQuery | undefined;
};

export const RegDocumentSearchResult: React.FC<
	RegDocumentSearchResultProps
> = props => {
	const hoveredRegulatoryDocument = undefined;
	const setHoveredRegulatoryDocument = () => undefined;
	const fetchSummaryData = async () => [];
	const loadingSummary = false;
	const {t: tEnum} = useTranslation('common/enums');

	const columnsInfinity = useReportsPageColumn(
		hoveredRegulatoryDocument,
		setHoveredRegulatoryDocument,
		fetchSummaryData,
		loadingSummary,
	);

	const propsResult = useMemo(() => {
		const columns: EntityListColumn[] = getEntityListColumns(
			columnsInfinity,
			primitiveColumns,
			arrayColumns,
			dateColumns,
			omitColumns,
		).map(x => {
			if (x.key === 'status') {
				return {
					...x,
					getFilterKey: (x: any) => x,
					getFilterLabel: (value: any) =>
						tEnum(`RegulatoryDocumentStatus.${value}`),
				};
			}
			return x;
		});

		const searchedItems =
			props.documentData?.searchRegulatoryDocuments.regulatoryDocuments || [];

		const renderCard = (item: Regulation) => (
			<SearchResultRegulatoryDocument key={item.id} item={item} />
		);

		const renderEntityList = (EntityList: JSX.Element) => {
			return (
				<ReportsTooltipTranslationProvider>
					{EntityList}
				</ReportsTooltipTranslationProvider>
			);
		};

		return {
			...props,
			entityName,
			searchedItems,
			columns,
			quickFilterColumns,
			renderCard,
			renderEntityList,
		};
	}, [props]);

	return <SearchResult {...propsResult} />;
};
